module.exports = __webpack_public_path__ + "cbda94e9142313eeea0414f92b30007b.svg";